<app-slide-out
  [isSlideOutOpen]="isSlideOutOpen()"
  title="The homeowner advantage"
  (closeSlideOut)="closeSlideOut()"
>
  <div>
    <p class="be-body-s-bold md:be-body-m-bold text-navy-800">
      The Best Egg Secured Loan + Homeowner Discount uses permanent fixtures like lighting, cabinets, and vanities within your home as collateral to help you secure a loan up to $100k at a great rate without putting a lien on your entire home.
    </p>

    <div class="box-shadow-navy-tint-700 relative overflow-hidden bg-navy-tint-200 mt-6 px-5 py-8 rounded-2xl">
      <app-logo-bestegg-white
        class="absolute right-0 -top-3 h-32 w-32 opacity-35 rotate-[-10deg] z-0 text-navy-tint-100"
      ></app-logo-bestegg-white>
      <div class="relative z-10">
        <p class="be-text-s-bold md:be-text-m-bold mb-3 text-navy-700">
          Lower rates, same easy process
        </p>
        <p class="heading-xs-bold md:heading-s-bold text-navy-900">
          No appraisals, receipts, or extensive paperwork required
        </p>
      </div>
    </div>

    <p class="be-eyebrow-text text-navy-900 mt-9">
      <span class="partial-highlight-sunflower">The benefits</span>
    </p>
    <ul class="space-y-3 list-none p-0 mt-3 mb-0">
      <li class="flex items-center gap-3 p-4 rounded-lg bg-oat-800">
        <app-icon-circle-check
          circleColor="#FFDC82"
          class="h-6 w-6 shrink-0"
        ></app-icon-circle-check>
        <p class="be-body-s-bold md:be-body-m-bold text-navy-900 m-0">Average APR savings of 20%* compared to our unsecured loans</p>
      </li>
      <li class="flex items-center gap-3 p-4 rounded-lg bg-oat-800">
        <app-icon-circle-check
          circleColor="#FFDC82"
          class="h-6 w-6 shrink-0"
        ></app-icon-circle-check>
        <p class="be-body-s-bold md:be-body-m-bold text-navy-900 m-0">A lien on just your home's fixtures means no risk of foreclosure</p>
      </li>
      <li class="flex items-center gap-3 p-4 rounded-lg bg-oat-800">
        <app-icon-circle-check
          circleColor="#FFDC82"
          class="h-6 w-6 shrink-0"
        ></app-icon-circle-check>
        <p class="be-body-s-bold md:be-body-m-bold text-navy-900 m-0">Fixed rates for predictable monthly payments and reasonable terms</p>
      </li>
    </ul>

    <div class="mt-6 p-4 rounded-lg bg-oat-800">
      <p class="be-text-s-bold text-navy-900 m-0">Your credit score is safe</p>
      <p class="be-body-s text-navy-900 mt-2 mb-0">
        As always, you can get your rate in minutes with no impact to your credit score. You'll get your funds in as little as 24 hours following approval. Use your cash for anything from debt consolidation, to home repairs.
      </p>
    </div>

    <section class="mt-6">
      <h4 class="sr-only">FAQs</h4>
      <app-faq-accordion-item
        id="hslHeloc"
        title="How is this different than a home equity loan or HELOC?"
      >
        <p class="pt-2 be-body-s text-navy-800">
          Home equity lines of credit, or HELOCs, allow homeowners to borrow against the equity in their homes by placing a lien on the entire home as collateral required for funding. The Best Egg Secured Loan + Homeowner Discount puts a lien only on the fixtures of the home like cabinets, vanities and lighting, not the entire home, to fund your loan.
        </p>
      </app-faq-accordion-item>

      <app-faq-accordion-item
        id="hslAppraisal"
        title="How are fixtures valued without appraisals?"
      >
        <p class="pt-2 be-body-s text-navy-800">
          No appraisal is needed as the lien on the fixtures for the value of the loan serves as collateral.
        </p>
      </app-faq-accordion-item>

      <app-faq-accordion-item
        id="hslRepossession"
        title="Can fixtures be repossessed if I fall behind on payments?"
      >
        <p class="pt-2 be-body-s text-navy-800">
          We won't repossess your fixtures if you fall behind on payments. The lien is there to secure your loan, which remains until it's paid in full. If you have a balance due and go to sell or refinance, the lien ensures your loan will be repaid before or during the closing process.
        </p>
      </app-faq-accordion-item>

      <app-faq-accordion-item
        id="hslWhoShouldConsider"
        title="Who should consider a Secured Loan + Homeowner Discount?"
      >
        <ol class="pt-2 pl-0 be-body-s text-navy-800 list-decimal list-inside space-y-1 m-0">
          <li>You have high-interest debts that you want to consolidate into a more affordable rate</li>
          <li>You need extra cash for home improvements or repairs</li>
          <li>You need a low-rate loan but don't want to use your entire home for collateral</li>
          <li>You need a loan term that ranges from 5-7 years</li>
        </ol>
      </app-faq-accordion-item>
    </section>

    <div class="mt-6 mb-9">
      <p class="be-hint text-navy-600 mb-4">
        *Based on the average APR for our 36-month Secured Loan + Homeowner Discount vs. Unsecured Personal Loan.
      </p>
      <button
        (click)="openDisclosure()"
        class="disclosure-btn be-body-s-link text-navy-700"
      >
        {{ offer()?.label }}
      </button>
    </div>
  </div>

  <div slideOutFooter class="shrink-0 flex gap-10 justify-end py-5 px-6 md:px-10 shadow-1.2lg bg-white">
    <button
      (click)="closeSlideOut()"
      class="cancel-btn be-btn be-btn--small be-btn--link text-navy-900"
    >
      No, thanks
    </button>
    <a
      [href]="offer()?.offerUrl"
      target="_blank"
      rel="noopener noreferrer"
      class="view-offers-link be-btn be-btn--small no-underline"
      (click)="fireGetOfferEvents()"
    >View offers</a>
  </div>
</app-slide-out>
